// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const FirebaseConfig = {
  apiKey: "AIzaSyDEe4ctUNC5iCuQ2dSGToNlYnoRdwEaj2Q",
  authDomain: "audiovideoimage-89e2e.firebaseapp.com",
  databaseURL: "https://audiovideoimage-89e2e.firebaseio.com",
  projectId: "audiovideoimage-89e2e",
  storageBucket: "audiovideoimage-89e2e.appspot.com",
  messagingSenderId: "452703896061",
  appId: "1:452703896061:web:10bc56dc836de1a97d5994",
};

// Initialize Firebase

export default FirebaseConfig;
